import { Component, OnInit } from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {ApiService} from '../../services/api-service/api.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-page-equipment',
  templateUrl: './page-equipment.component.html',
  styleUrls: ['./page-equipment.component.scss']
})
export class PageEquipmentComponent implements OnInit {


  public equipments: any[];
  public staticUrl: string;

  onHover = (event) => {
    let img = <HTMLElement> event.target.querySelectorAll('.eq-img')[0];
    let content = <HTMLElement> event.target.querySelectorAll('.equipment-desc')[0];
    let title = <HTMLElement> event.target.querySelectorAll('.eq-title')[0];
    title.classList.toggle('hidden');
    img.classList.toggle('blured');
    content.classList.toggle('visible');
  }

  openModal = (event) => {
    this.UIService.toggleCallbackModal(event);
  }

  constructor(private UIService: UiService,private apiService: ApiService) {
    this.equipments = this.apiService.equipments;
    this.staticUrl = this.apiService.static_link;

    setTimeout(function(){        
      $('.app-loading').css('display','flex');
      $('.app-loading').delay(1000).fadeOut('slow'); 
  }, 0);

  }

  ngOnInit() {
  }

}
